import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { LayoutModule } from '../../layout/layout.module';
import { NzCardModule, NzLayoutModule } from 'ng-zorro-antd';
import { QrPaymentComponent } from './qr-payment/qr-payment.component';
import { MemberLoginComponent } from './member-login/member-login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

const routes: Routes = [
  {path: '', component: LoginComponent},
];

@NgModule({
  declarations: [LoginComponent, QrPaymentComponent, MemberLoginComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    LayoutModule,
    NzLayoutModule,
    NzCardModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [RouterModule, MemberLoginComponent, QrPaymentComponent]
})
export class LoginModule {
}
